import React, { useCallback, memo } from 'react';
import { ArrowRight, MapPin } from 'lucide-react';
import { ImageWithFallback } from './figma/ImageWithFallback';
import { UpcomingEvent } from '../services/api';
import { getEventPresentation } from '../lib/eventPresentation';
import { useScrollReveal } from '../lib/useScrollReveal';

interface EventCardProps {
  event: UpcomingEvent;
  onClick?: () => void;
  imageLoading?: 'lazy' | 'eager';
}

function EventCardComponent({ event, onClick, imageLoading = 'lazy' }: EventCardProps) {
  const reveal = useScrollReveal<HTMLAnchorElement>();
  const handleClick = useCallback((clickEvent: React.MouseEvent<HTMLAnchorElement>) => {
    if (!onClick) return;
    clickEvent.preventDefault();
    onClick();
  }, [onClick]);
  const { name, venue, date } = getEventPresentation(event);
  const art = event.thumbnailUrl || event.imageUrl;

  return (
    <a {...reveal} href={event.eventUrl || '#'} target="_blank" rel="noopener" onClick={handleClick} className="event-tile" aria-label={[name, venue, date].filter(Boolean).join(' — ')}>
      <div className="event-tile__art">
        {/* A arte cadastrada e quadrada; a propria arte desfocada preenche o cartao 3:4 sem cortar nada. */}
        {art && <img className="event-tile__backdrop" src={art} alt="" aria-hidden="true" loading={imageLoading} decoding="async" />}
        <ImageWithFallback src={art} alt={name} className="event-tile__image" loading={imageLoading} />
      </div>
      <div className="event-tile__content">
        <h3 className="event-tile__name">{name}</h3>
        {venue && <span className="event-tile__location"><MapPin size={14} aria-hidden="true" />{venue}</span>}
        <div className="event-tile__meta">
          <span className="event-tile__date">{date}</span>
        </div>
        <span className="event-tile__action">Ver ingressos <ArrowRight size={16} aria-hidden="true" /></span>
      </div>
    </a>
  );
}

export const EventCard = memo(EventCardComponent);
